import {gsap} from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// const asbBar = document.querySelector('.p-wrap__dec--bar'),
//       asbWrap = document.querySelector('.p-wrap__dec--bar__wrap');
// if(asbBar) {
//   gsap.to(asbBar, {
//     scrollTrigger: {
//       trigger: '.p-wrap__dec--bar',
//       start: 'top top',
//       end: () => '+=' + (asbWrap.clientHeight),
//       // markers: true,
//       pin: true,
//     }
//   })
// }


// Smoother
// ScrollSmoother.create({
//   smooth: 1,
//   effects: true,
//   smoothTouch: 0.1
// });